import { Component, OnInit } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastMessage } from './toast';
import { Observable } from 'rxjs';
import { Animations } from '../shared/animations/animations';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [Animations.PopUpDown]
})
export class ToastComponent implements OnInit {
  message: ToastMessage;
  counter: number;
  constructor(public toastService: ToastService) {
    this.counter = 0;
    this.message = this.toastService.message;
  }

  ngOnInit() {}

  close() {
    this.toastService.closeMessage();
  }
}
